/**
 * @generated SignedSource<<9997bef9f319cb4f9014d445188f50b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField$data = {
  readonly text: string;
  readonly " $fragmentType": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField";
};
export type summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField$key = {
  readonly " $data"?: summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField$data;
  readonly " $fragmentSpreads": FragmentRefs<"summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "summary_softwareReleasesVersionDetailIssueList_jiraIssueSummaryField",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "text"
      },
      "action": "THROW",
      "path": "text"
    }
  ],
  "type": "JiraSingleLineTextField"
};

(node as any).hash = "ecdba23eb4bd24552ee157f9d7e6c2dc";

export default node;
